import React, { ReactChild, useReducer } from "react";
import { Logger } from "../logging/logger";

export interface ProductBuilderContextType {
  satisfactionGuaranteedInView: boolean;
  setSatisfactionGuaranteedInView: (satisfactionGuaranteedInView: boolean) => void;
}

export const ProductBuilderContext = React.createContext<ProductBuilderContextType>({
  satisfactionGuaranteedInView: false,
  setSatisfactionGuaranteedInView: () => {},
});

export interface ProductBuilderContextProviderProps {
  children?: ReactChild | ReactChild[] | undefined | null;
}

export interface ProductBuilderState {
  satisfactionGuaranteedInView: boolean;
}

export const ProductBuilderContextProvider = (props: ProductBuilderContextProviderProps) => {
  const initialState: ProductBuilderState = {
    satisfactionGuaranteedInView: false,
  };

  const productBuilderReducer = (state: ProductBuilderState, action: any) => {
    switch (action.type) {
      case "setSatisfactionGuaranteedInView": {
        return {
          ...state,
          satisfactionGuaranteedInView: action.satisfactionGuaranteedInView,
        };
      }
      default: {
        Logger.instance.error("Unknown action in product builder state", {
          actionType: action.type,
        });
        return { ...state };
      }
    }
  };

  const [state, dispatch] = useReducer(productBuilderReducer, initialState);
  const { satisfactionGuaranteedInView } = state;
  const { children } = props;

  const setSatisfactionGuaranteedInView = (satisfactionGuaranteedInView: boolean) => {
    dispatch({
      type: "setSatisfactionGuaranteedInView",
      satisfactionGuaranteedInView,
    });
  };

  return (
    <ProductBuilderContext.Provider
      value={{
        satisfactionGuaranteedInView,
        setSatisfactionGuaranteedInView,
      }}
    >
      {children}
    </ProductBuilderContext.Provider>
  );
};
